import { canMarkOrderChecked, orderIsChecked } from '../../lib/demOrderChecked';

type OrderCheckedFields = {
  status: string;
  checked_at: string | null;
  checked_at_display: string;
  checked_by: string;
};

type OrderCheckedControlProps = {
  order: OrderCheckedFields;
  busy?: boolean;
  compact?: boolean;
  onMark: () => void;
  onUnmark?: () => void;
};

/** NAV Checked control — only actionable when status is Processed. No undo in UI. */
export function OrderCheckedControl({
  order,
  busy,
  compact,
  onMark,
}: OrderCheckedControlProps) {
  const checked = orderIsChecked(order);
  const canMark = canMarkOrderChecked(order);

  if (checked) {
    return (
      <span className={`dem-order-checked${compact ? ' dem-order-checked--compact' : ''}`}>
        <span className="dem-order-checked__badge" title={`${order.checked_by} · ${order.checked_at_display}`}>
          Checked
        </span>
        {!compact ? (
          <span className="dem-order-checked__meta">
            {order.checked_by}
            {order.checked_at_display !== '—' ? ` · ${order.checked_at_display}` : ''}
          </span>
        ) : null}
      </span>
    );
  }

  if (canMark) {
    return (
      <button
        type="button"
        className="dem-order-checked__btn dem-order-checked__btn--mark"
        disabled={busy}
        onClick={(e) => {
          e.stopPropagation();
          onMark();
        }}
      >
        {busy ? '…' : 'Checked?'}
      </button>
    );
  }

  return <span className="dem-order-checked__empty">—</span>;
}
